import type {
  CheckerDirection,
  CheckerShape,
} from '@xzx-design/components/checkbox'
import type { InjectionKey } from 'vue/dist/vue'

import type { RadioGroupProps } from './radio-group'

export type RadioShape = CheckerShape | 'dot'

export type RadioThemeVars = {
  radioSize?: string
  radioDotSize?: string
  radioBorderColor?: string
  radioDuration?: string
  radioLabelMargin?: string
  radioLabelColor?: string
  radioCheckedIconColor?: string
  radioDisabledIconColor?: string
  radioDisabledLabelColor?: string
  radioDisabledBackground?: string
}

export type RadioGroupDirection = CheckerDirection

export type RadioGroupProvide = {
  props: RadioGroupProps
  updateValue: (value: unknown) => void
}

export const RADIO_KEY: InjectionKey<RadioGroupProvide> =
  Symbol('xzxRadioGroup')
